<template>
	<div class="base_result">
		<div class="icon">
			<img v-if=" type==='success' " src="@/assets/icon/icon_result_success.png" alt="" />
			<img v-if=" type==='error' " src="@/assets/icon/icon_result_error.png" alt="" />
			<img v-if=" type==='wait' " src="@/assets/icon/icon_result_wait.png" alt="" />
		</div>
		<div class="explain" v-if="text">
			<p>{{ text }}</p>
		</div>
		<div class="action">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BaseResult',
		props: {
			type: {
				type: String,
				default: 'success'
			},
			text: {
				type: String,
				default: ''
			}
		}
	};
</script>

<style scoped lang="less">
	.base_result {
		text-align: center;
		.icon {
			padding: 100px 0 40px;
			&>img {
				width: 160px;
				height: 160px;
			}
		}
		.explain {
			font-family: PingFangSC-Medium;
			font-size: 36px;
			font-weight: 500;
			color: #1F2329;
		}
		.action {
			width: 360px;
			margin: 100px auto 50px;
		}
	}
</style>
